import React, { Component, PropTypes } from 'react';

import DoyouKnow from '../partials/qlink_partials/DoyouKnow';
import NewPost from '../partials/qlink_partials/NewPost';
import NoticeBoard from '../partials/qlink_partials/NoticeBoard';
import SupportDesk from '../partials/qlink_partials/SupportDesk';
import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';
const $=window.$;

const styles={
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    float: 'left',
    width: '100%',
    position: 'absolute',
    height: '100%'
};

class RightMenuLayout extends Component {

    constructor(props) {
        super(props);      

        this.state={
            
            compBlock:null
        };
    }


    emptyFunc(){

    }

    noAuthorizedPage(){
        return <div style={styles}>You are not authorized to access this page!"</div>;
    }


    getComponent(){

        
        let type=this.props.params.type;
        let app_code =this.props.params.app_code;
        let device_id = this.props.params.device_id;
        
        let component=null;
          
        switch (type) {
            case "doyouknow":
                component = <DoyouKnow Webview='webview'  />;
                break;
            case "newpost":
                component = <NewPost Webview='webview' appcode={app_code} device_id={device_id}/>;
                break;
            case "notice-board":
                component = <NoticeBoard Webview='webview'/>;
                break;
            case "support-desk":
                component = <SupportDesk Webview='webview'/>;
                break;
            default:
                component =this.noAuthorizedPage()

        }
        this.setState({
            compBlock:component
        })
        
        $("#contentsection").addClass('mobileapp');

           
    }

    
    componentDidMount () {


        Common.reactLoader("show", "Please wait...");

        let query_data=Common.objToSlashString({

            app_code:this.props.params.app_code,
            device_id:this.props.params.device_id
           });


        fetch(Config.domainUrl + 'mobile/learner/check' +query_data, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status == 1) {

              
                Common.setTokenData("token", responseJson.data.token);
            

             this.getComponent();

            }else{
              
                this.setState({
                    compBlock:this.noAuthorizedPage()
                })
            }
            
            Common.reactLoader("hide");
        });

    }

    render () {
        return (
            <div>
                {this.state.compBlock}
            </div>
        )
    }
}

export default RightMenuLayout;




// WEBPACK FOOTER //
// ./src/layouts/RightMenuLayout.js